import Sortable from "sortablejs/modular/sortable.complete.esm.js";

export default (vnode, group, dataIdAttr, groupoptions, options = {}) => {
	function chainFunctions(f1, f2) {
		if (f1 && f2)
			return function (...args) {
				f1.apply(this, args);
				f2.apply(this, args);
			};
		return f1 || f2;
	}
	let currentOrder = [];

	const original = vnode;
	const attrs = vnode.attrs || {};
	const children = vnode.children;
	//const localoptions = {pull: true, put: true, sort: true, ...options};
	// console.log({options, groupoptions});
	const enhancedAttrs = {
		...attrs,
		oncreate: chainFunctions(attrs.oncreate, (vnode) => {
			Sortable.create(vnode.dom, {
				group: {
					name: group,
					...groupoptions,
				},
				//delay: 100,
				animation: 150,
				fallbackOnBody: true,
				swapThreshold: 0.65,
				dataIdAttr: dataIdAttr || "data-uid",
				...options,
				// onChange: (e) => {
				// 	console.log("onChange", {e});
				// },
				store: {
					set(sortable) {
						const order = sortable.toArray().map((id) => ({id}));
						console.log("in sortable", {order, arr: sortable.toArray()});
						currentOrder = order;
						if (attrs.onchange) attrs.onchange(order);
					},
				},
			});
		}),
	};

	return {
		...original,
		attrs: enhancedAttrs,
		children,
	};
};
